import * as React from 'react'

import './Preloader.scss'

interface PreloaderProps {
  hidden?: boolean
}

const Preloader: React.FC<PreloaderProps> = ({ hidden = true }: PreloaderProps) => {
  return (
    <div className={`srprs-preloader ${hidden ? 'is-hidden' : ''}`}>
      <div className="dot" />
      <div className="shadow" />
    </div>
  )
}

export default Preloader
